var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVariation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 11,
    height: 11,
    fill: "url(#pattern0_641_460)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_641_460",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_641_460",
    transform: "scale(0.03125)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_641_460",
    width: 32,
    height: 32,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAAA7DAAAOwwHHb6hkAAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAAYhJREFUWIXtl8FKAlEUhs+5c7lIszA3iQOGDTIptEpxp4/QC9hD+Cg+RL1AvkHuJFoFUyIWCYltqsWADXfmtJgZi5jmKiRu7r/++O/P5fKfc9GyGnvEvTootOT+5G06/bAqTo1CZqYxyELv5Wl8X7DtfE6KqsoTpely4l6diG5UsJDiDAAGYYCXAHSaxlCAtwDQEFJ0iOhK5QncazIltGXpADqADrDzAHzJ/UlcMpkig48AABCoFyLbT2MYhe8rNpBKz0/uTzYN/O9Cq+LUonpVgEC9+Ww8LB4eXyBB6uwgBHfx/HBeKjttAuyrPJlBXR4NlvRu/6nk2uPDU3mkbxZJ7UkhM3f+CHUAHYAjC714k8nUqmQQ3OS1/xYhuAlLoPZEFnqbxd2CsGDbeSFFRwWSwUevj3eLUtlpZ1XxfDYeHhydFDGQLZWnz/1rnpOiutYCGXX7gAD7f5VMfO0NDGQL1/DMSaGXUh1AB9ABgKM0XeBeUwUmCyQzqJv1PQeIGi4nhdITpel+ASwApqv1mX7kAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVariation);
export default __webpack_public_path__ + "static/media/variation.6f1d009ad7c1f87192597de50a9f69f8.svg";
export { ForwardRef as ReactComponent };